export const MINUTE_MS = 60000
export const HOUR_MS = MINUTE_MS * 60
export const DAY_MS = HOUR_MS * 24
export const GENESIS_TIME = '2020-09-10T00:00:00Z'
